import React from 'react';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { useConfiguration } from '../../context/configurationContext';
import {
  Page,
  LayoutSingleColumn,
  SimpleSection,
  SectionSimpleDescription,
  IconHeart,
  PreviewIcon,
  PazzleIcon,
  NamedLink,
  SectionSimpleHero,
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import SectionHero from '../LandingPage/SectionHero/SectionHero';

import css from './AboutUsPage.module.css';

export const AboutUsPageComponent = props => {
  const { history, intl, location, scrollingDisabled } = props;

  const config = useConfiguration();

  const marketplaceName = config.marketplaceName;
  const schemaTitle = intl.formatMessage({ id: 'AboutUsPage.schemaTitle' }, { marketplaceName });
  const schemaDescription = intl.formatMessage({ id: 'AboutUsPage.schemaDescription' });

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.heroContainer}>
          <SectionHero
            rootClassName={css.heroRoot}
            className={css.hero}
            history={history}
            location={location}
            title={'AboutUsPage.heroTitle'}
            titleCustom={'AboutUsPage.heroTitleCustom'}
            subTitle={'AboutUsPage.heroSubTitle'}
            description={'AboutUsPage.heroDescription'}
            browseButton={null}
            linkAddress={null}
            heroImgLink={null}
          />
        </div>
        <ul className={css.sections}>
          <li className={classNames(css.section, css.backgroundWhite)}>
            <SimpleSection
              icon={<IconHeart />}
              className={css.heartIconWrapper}
              title={intl.formatMessage({ id: 'AboutUsPage.ourMissionTitle' })}
              description={intl.formatMessage({ id: 'AboutUsPage.ourMissionDescription' })}
            />
          </li>
          <li className={classNames(css.section, css.backgroundRed)}>
            <SimpleSection
              className={css.previewIconWrapper}
              icon={<PreviewIcon />}
              title={intl.formatMessage({ id: 'AboutUsPage.ourStoryTitle' })}
              description={intl.formatMessage(
                { id: 'AboutUsPage.ourStoryDescription' },
                { br: <br /> }
              )}
            />
          </li>
          <li className={classNames(css.section, css.backgroundWhite, css.sectionDesktop)}>
            <SimpleSection
              className={css.pazzleIconWrapper}
              icon={<PazzleIcon />}
              title={intl.formatMessage({ id: 'AboutUsPage.ourChallengesTitle' })}
              description={intl.formatMessage({ id: 'AboutUsPage.ourChallengesDescription' })}
            />
          </li>
          <li className={classNames(css.section, css.backgroundYellow)}>
            <SectionSimpleHero />
          </li>
          <li className={classNames(css.section, css.backgroundWhite, css.sectionMobile)}>
            <SimpleSection
              className={css.pazzleIconWrapper}
              icon={<PazzleIcon />}
              title={intl.formatMessage({ id: 'AboutUsPage.ourChallengesTitle' })}
              description={intl.formatMessage({ id: 'AboutUsPage.ourChallengesDescription' })}
            />
          </li>
          <li className={classNames(css.section, css.backgroundWhite)}>
            <SectionSimpleDescription
              className={css.descriptionSectionRoot}
              description={intl.formatMessage(
                { id: 'AboutUsPage.descriptionSection' },
                {
                  link: (
                    <NamedLink name="SignupPage">
                      {intl.formatMessage({ id: 'AboutUsPage.descriptionSectionLink' })}
                    </NamedLink>
                  ),
                }
              )}
            />
          </li>
        </ul>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const AboutUsPage = compose(
  withRouter,
  connect(mapStateToProps),
  injectIntl
)(AboutUsPageComponent);

export default AboutUsPage;
